// External libraries
import gql from 'graphql-tag';

export const FUNDING_OPTIONS_FRAGMENT = gql`
  fragment fundingOptions on CheckoutSession {
    fundingOptions {
      allPlans {
        fundingSources {
          fundingInstrument {
            id
          }
          amount {
            currencyCode
            currencyValue
          }
        }
        fundingContingencies {
          ... on OpenBankingContingency {
            encryptedId
            contingencyReasons
            contingencyType
          }
        }
      }

      fundingInstrument {
        id
        lastDigits
        name
        nameDescription
        type
      }
    }
  }
`;
